import { Option } from '../CustomSelect';

interface IParams {
  isUseInput: boolean;
  options: Option[];
  search: string;
}

export const getFilterOptions = ({ options, search, isUseInput }: IParams) => {
  let newOptions: Option[] = [];

  newOptions = options?.filter((option) => !option.isDisabled);

  if (isUseInput) {
    newOptions = options?.filter((option) =>
      option?.name?.toLowerCase().includes(search.toLowerCase())
    );
  }

  return newOptions;
};
